export const signUpSuccess = 'Succesfully registered! You\'ve been signed in as well.'
export const signUpFailure = 'Registration failed. Email may be taken, or passwords don\'t match.'
export const signInSuccess = 'Welcome!'
export const signInFailure = 'Failed to sign in. Check your email and password and try again.'
export const signOutSuccess = 'Come back soon!'
export const changePasswordSuccess = 'Password changed successfully!'
export const changePasswordFailure = 'Failed to change passwords. Check your old password and try again.'
export const addedToCartSuccess = 'Successfully added item to cart.'
export const addedToCartFailure = 'Please sign in or sign up for an account.'
export const checkoutSuccess = 'Thank you for your business.'
export const checkoutFailure = 'Something went wrong.'
